import { render, staticRenderFns } from "./ReferencesPage.vue?vue&type=template&id=1c6f43a2&scoped=true&"
import script from "./ReferencesPage.vue?vue&type=script&lang=js&"
export * from "./ReferencesPage.vue?vue&type=script&lang=js&"
import style0 from "./ReferencesPage.vue?vue&type=style&index=0&id=1c6f43a2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c6f43a2",
  null
  
)

component.options.__file = "ReferencesPage.vue"
export default component.exports